import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Feed from "@/pages/Feed";
import Network from "@/pages/Network";
import Profile from "@/pages/Profile";
import Chat from "@/pages/Chat";
import Meet from "@/pages/Meet";
import MeetingRoom from "@/pages/MeetingRoom";
import { Toaster } from "sonner";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-mono text-sm">LOADING…</div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
        <Route index element={<Navigate to="/app/messages" replace />} />
        {/* Messages (default home) */}
        <Route path="messages" element={<Chat />} />
        <Route path="messages/:convId" element={<Chat />} />
        {/* Network */}
        <Route path="network" element={<Feed />} />
        <Route path="people" element={<Network />} />
        <Route path="profile/:userId" element={<Profile />} />
        {/* Meet */}
        <Route path="meet" element={<Meet />} />
        <Route path="meet/room/:roomName" element={<MeetingRoom />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
